import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { LORAX } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import UIButton from 'UIComponents/button/UIButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import H5 from 'UIComponents/elements/headings/H5';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CommentModeCursorTooltip from './CommentModeCursorTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CommentModeIndicatorSharedStyle = css(["position:fixed;background-color:", ";overflow:hidden;z-index:", ";"], LORAX, URANUS_LAYER);
const TopIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__TopIndicator",
  componentId: "sc-1jb1moz-0"
})([".hs-private.hs-private.hs-private &{", " height:10px;width:100%;top:0;left:0;}"], CommentModeIndicatorSharedStyle);
const BottomIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__BottomIndicator",
  componentId: "sc-1jb1moz-1"
})([".hs-private.hs-private.hs-private &{", " height:10px;width:100%;bottom:0;left:0;}"], CommentModeIndicatorSharedStyle);
const LeftIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__LeftIndicator",
  componentId: "sc-1jb1moz-2"
})([".hs-private.hs-private.hs-private &{", " height:100%;width:10px;left:0;top:0;}"], CommentModeIndicatorSharedStyle);
const RightIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__RightIndicator",
  componentId: "sc-1jb1moz-3"
})([".hs-private.hs-private.hs-private &{", " height:100%;width:10px;right:0;top:0;}"], CommentModeIndicatorSharedStyle);
const ModeIndicator = styled(UIButton).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "CommentModeIndicator__ModeIndicator",
  componentId: "sc-1jb1moz-4"
})([".hs-private.hs-private.hs-private &&{", " right:0;top:0;border-bottom-left-radius:18px;}"], CommentModeIndicatorSharedStyle);
const ModeTitle = styled(H5).withConfig({
  displayName: "CommentModeIndicator__ModeTitle",
  componentId: "sc-1jb1moz-5"
})([".hs-private.hs-private.hs-private &{color:", ";margin:24px 60px 22px 30px;}"], ({
  theme
}) => theme.color['do-not-use-olaf']);
function CommentModeIndicator({
  onCancel
}) {
  /* TODO:The class names in here are used for style overrides
  in the email-editor-ui. A more scalable solution should be
  implemented that does not rely on class names and does not break
  existing behavior.
  */
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TopIndicator, {
      className: "top-indicator"
    }), /*#__PURE__*/_jsx(BottomIndicator, {
      className: "bottom-indicator"
    }), /*#__PURE__*/_jsx(LeftIndicator, {
      className: "left-indicator"
    }), /*#__PURE__*/_jsx(RightIndicator, {
      className: "right-indicator"
    }), /*#__PURE__*/_jsxs(ModeIndicator, {
      className: "comment-mode--indicator-button",
      onClick: onCancel,
      "data-test-id": "comment-mode-indicator",
      children: [/*#__PURE__*/_jsx(ModeTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "collaborationSidebar.modals.commentMode.title"
        })
      }), /*#__PURE__*/_jsx(UICloseButton, {
        className: "m-top-1 m-right-1",
        size: "medium"
      })]
    }), /*#__PURE__*/_jsx(CommentModeCursorTooltip, {
      className: "comment-mode-cursor-tooltip"
    })]
  });
}
CommentModeIndicator.propTypes = {
  onCancel: PropTypes.func.isRequired
};
export default CommentModeIndicator;